module.exports = __webpack_public_path__ + "img/chevron-down.a7b4bf80.svg";